import React, { useEffect, useState } from "react";
import TeamProfile from "./TeamProfile";
import { GetSupportTeamService } from "../../services/QualificationService";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import { Heading1 } from "../common/GlobalElements/Typography";
import { tokens } from "../../public/tokens";

export default function TeamBox(props) {
  const {teamData={}} = props;
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // fetch if teamData is empty
    if (Object.keys(teamData).length < 1) {
      setLoading(true)
      let mounted = true
      GetSupportTeamService({ sid: props.subjectId })
        .then((res) => {
          if (mounted) {
            setTeam(res.data.team);
            setLoading(false)
          }
        })
        .catch((error) => {
          setLoading(false)
        });

      return function cleanup() {
        mounted = false
      }
    }else{
      setTeam(teamData)
    }
  }, []);

  return (
    <>
      {loading && <div className="row support-team-skeleton"><SkeletonContainer height={getSkeletonHeight(3)} /></div>}
      {Object.keys(teamData).length < 1 ? props.subject__welcome && Object.keys(team).length !== 0 &&
        new DOMParser().parseFromString(props.subject__welcome, "text/html").body.textContent.trim() && <hr style={{ margin: "20px 0" }} />
       : null}
      {!loading && Object.keys(team).length !== 0 ? (
        <>
          <Heading1 fontWeight={tokens.typography.fontWeights.semibold} className="text-theme-topbar mb-3">Support Team</Heading1>
          <div className="container-fluid p-0">
            <div className="row mx-0">
              {team.coach && (
                <div className="col-lg-4 col-md-6 p-0" ><TeamProfile team={team.coach} profile="coach" /></div>
              )}
              {team.lecturer && (
                <div className="col-lg-4 col-md-6 p-0"><TeamProfile team={team.lecturer} profile="lecturer" /></div>
              )}
              {team.support && (
                <div className="col-lg-4 col-md-6 p-0"><TeamProfile team={team.support} profile="support" /></div>
              )}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
